import React from "react";
import { Button, Icon, Modal, Text } from "@/ui-kits";
import { formatName } from "@/utils/common_functions";

interface SpecialistWelcomeModalProps {
  open: boolean;
  onClose: () => void;
  onGoToProfile: () => void;
  specialistName?: string;
}

export const SpecialistWelcomeModal: React.FC<SpecialistWelcomeModalProps> = ({
  open,
  onClose,
  onGoToProfile,
  specialistName,
}) => {
  return (
    <Modal open={open} onClose={onClose} className="w-[95%] sm:w-full max-w-[820px] p-0 bg-transparent">
      {/* OUTER CONTAINER → WHITE */}
      <div className="overflow-hidden rounded-[20px] sm:rounded-[28px] bg-white w-[90%] sm:w-[95%] max-w-[780px] mx-auto my-2 sm:my-4">
        
        {/* Header stays same */}
        <div className="px-4 py-4 sm:px-8 sm:py-6">
          <Text variant="free" className="text-2xl sm:text-4xl font-FigtreeBold text-ui_blue">
            Welcome, Dr. {formatName(specialistName ?? "")}!
          </Text>
          <Text variant="free" className="text-base sm:text-xl font-FigtreeMeduim text-ui_input_border_dark mt-1 sm:mt-0">
            Your login is now active.
          </Text>
        </div>

        <div className="px-4 pb-5 sm:px-8 sm:pb-8">
          {/* INNER CARD */}
          <div className="rounded-[16px] sm:rounded-[24px] border border-ui_input_border bg-ui_bg_sky px-4 py-3 sm:px-6 sm:py-4">
            
            {/* First item */}
            <div className="flex items-start gap-3 sm:gap-4 py-4 sm:py-6">
              <div className="flex items-center flex-shrink-0">
                <div className="flex h-6 w-8 sm:h-8 sm:w-12 items-center justify-center rounded-lg sm:rounded-xl">
                  <Icon type="profile_logo" className="h-6 w-6 sm:h-8 sm:w-8" />
                </div>
              </div>

              <div className="flex-1 min-w-0">
                <Text variant="title" className="text-ui_blue text-base sm:text-lg font-FigtreeBold">
                  Complete Your Professional Profile
                </Text>
                <Text variant="body" className="mt-2 sm:mt-3 text-sm sm:text-xl font-FigtreeMeduim text-ui_blue leading-relaxed">
                  Your credentials have been verified, and you can now access your specialist dashboard. Before you start receiving consultations, please complete your professional profile — <br className="hidden sm:block" />including your photo and expertise details.
                </Text>
              </div>
            </div>

            {/* Second item */}
            <div className="flex items-start gap-3 sm:gap-4 py-4 sm:py-6">
              <div className="flex items-center flex-shrink-0">
                <div className="flex h-6 w-8 sm:h-8 sm:w-12 items-center justify-center rounded-lg sm:rounded-xl">
                  <Icon type="vector_logo" className="h-5 w-5 sm:h-6 sm:w-6" />
                </div>
              </div>

              <div className="flex-1 min-w-0">
                <Text variant="title" className="text-ui_blue text-base sm:text-lg font-FigtreeSemiBold">
                  Submit for Admin approval
                </Text>
                <Text variant="body" className="mt-2 sm:mt-3 text-sm sm:text-xl font-FigtreeMeduim text-ui_blue leading-relaxed">
                  Once you submit your profile, our admin team will review your details. <br className="hidden sm:block" />After approval, your profile will become visible to patients.
                </Text>
              </div>
            </div>

            {/* CTA inside card */}
            <div className="pb-2 sm:pb-4">
              <Button
                title="Go to My Profile"
                onClick={onGoToProfile}
                className="rounded-lg sm:rounded-xl w-full sm:w-[30%] bg-gradient-to-br from-ui_blue to-ui_blue_light py-2.5 sm:py-2 px-4 sm:px-6 border border-ui_blue/90 ml-0 sm:ml-[60px]"
                textClassName="text-sm sm:text-base font-FigtreeSemiBold text-white text-center w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SpecialistWelcomeModal;
